<template>
	<div>
		<router-link v-if="!provider_view" tag="a" :to="{ name : `${router_origin}.courses.detail`, params : { id : $route.params.id, section:'sessions' }}" class="">
			<img class="mr-1" src="../../assets/images/u315.svg"/> Back to Program Session

		</router-link>
		<label v-if="table_view">Sessions*</label>
		<v-select v-if="table_view" class="green green-dark bg-gray v-select-no-height" :options="session_list" label="name"  v-model="selected_session" @input="$emit('fetchSessionData', $event)" @search="assignCurrentSeach($event)">
			<template v-slot:option="option">
				<!-- <span :class="option.icon"></span> -->
				{{ option.name }}
			</template>
			<template #no-options>
				<a @click="createNewSessionActive()">Create New Session for <b>{{new_session_key}}</b> <img class="mr-1" src="../../assets/images/icons/solid/plus-circle-green.svg" width="13"/></a>
			</template>
		</v-select>

		<div v-if="create_new_session || create_view || edit_view" class="mt-2 mb-2" :class="{'new_session_border': no_border}">
			<div class="input-content flex">
				<input :disabled="completed_session_view" placeholder="Session Name" type="text" v-validate="'required'" v-model="session_data.name" class="form-control" name="session_name">
				<span class="input-error-msg">{{ errors.first('session_name') }}</span>

				<button v-if="edit_view && !completed_session_view"  class="button button-small mr-2">Cancel</button>
				<button v-if="edit_view && !completed_session_view" :class="{'input-disabled': disable_save}" class="button button-small" @click.prevent="saveSession()">Save</button>

			</div>
			<div class="form-group input-content input-content-single-line">
				<label>Supervisor</label>
				<input :disabled="completed_session_view" placeholder="Supervisor name" type="text" v-validate="'required'" v-model="session_data.supervisor" class="form-control" name="session_supervisor">
				<span v-if="errors.first('session_supervisor')" class="input-error-msg">Supervisor name is required</span>
			</div>
			<div  class="form-group input-content input-content-single-line">
				<label>Schedule To</label>
				<datetime :disabled="completed_session_view" placeholder="Schedule date*" class="session_date_picker_width" type="date" v-validate="'required'" v-model="session_data.scheduled_at" name="session_schedule_date"></datetime>
				<span v-if="errors.first('session_schedule_date')" class="input-error-msg">Schedule Date is required</span>
			</div>
			<!-- <div  class="form-group input-content input-content-single-line">
				<label>Participant Limit</label>
				<input :disabled="completed_session_view" placeholder="Participant Limit" type="number" v-model="session_data.providers_count" class="form-control" name="session_paticipant_limit">
				<span class="input-error-msg">{{ errors.first('session_paticipant_limit') }}</span>
			</div> -->
			<div v-for="(session_elem, index) in session_data.properties" class="form-group input-content input-content-single-line" :key="session_elem.id">
			
					<input placeholder="Ex. Class Name" v-validate="'required'" v-model="session_data.properties[index].key" class="form-control" :name="'session_custom_key' + session_elem.id">
					<span v-if="errors.first('session_custom_key' + session_elem.id)" class="input-error-msg right-50" >This field is required</span>

					<input placeholder="Ex. Class B-27" v-validate="'required'" v-model="session_data.properties[index].value" class="form-control" :name="'session_custom_value' + session_elem.id">
					<span v-if="errors.first('session_custom_value' + session_elem.id)" class="input-error-msg" >This field is required</span>
					<button class="button button-small" @click="removeSessionElement(index)"> <img class="mr-1" src="../../assets/images/icons/solid/minus-circle.svg" width="17"/></button>

			</div>
			<div v-if="!completed_session_view" class="form-group input-content input-content-single-line">
				<button class="button button-small" @click="insertCustomSessionInfo()">Add Info <img class="mr-1" src="../../assets/images/icons/solid/plus-circle-green.svg" width="15"/></button>
			</div>

			<div v-if="edit_view" class="mt-3">
			
				<div class="table-responsive">
					<div v-if="completed_session_view && session_data.providers.length > 0" class="button-position-display">
						<button class="print-button print-color button width-auto mb-2" @click="downloadAllCertificates(session_data.report_url)"><img class="img-font-size" id=""  src="../../assets/images/icons/solid/file-white.svg" width="13"/> Download Session Report </button>

						<button  class="print-button button print-color width-auto mb-2" @click="downloadAllCertificates()"> <img class="img-font-size" id=""  src="../../assets/images/icons/solid/file-archive_white.svg" width="13"/> All Certificates</button>
						<h5>Providers</h5>
					</div>

					<div v-else class="button-position-display">
						<h5 v-if=" session_data.providers.length > 0" >Providers</h5>
						<button v-if="!completed_session_view" class="print-button print-color button width-auto mb-2" @click="openProviderPage()"> Add participants to session</button>
					</div>

					<table v-if="session_data.providers.length > 0" class="table table-bordered loadable table-xs" >
						<thead>
								<th v-for="(head, index) in headers" :key="index">{{head}}</th>
						</thead>
								<tbody>
									<tr class="session_table" v-for="(item, index) in session_data.providers" :key="index" >
										
										<td :class="{'provider-removed' : item.removed}">{{item.provider_id}}</td>
										<td :class="{'provider-removed' : item.removed}">{{item.first_name}} {{item.last_name}}</td>
										<td :class="{'provider-removed' : item.removed}">{{item.phone}}</td>
										<td v-if="!completed_session_view"> 
											<button v-if="item.removed" class="button button-small" @click="addProvider(item, index)">Add Back <img class="mr-1" src="../../assets/images/icons/solid/plus-circle-green.svg" width="15"/></button>
											<button v-else class="button button-small" @click="removeProvider(item, index)"> <i class="fa fa-times" scale="2" variant="danger"></i></button>
										</td>
										<td v-else>
											<a @click="downloadAllCertificates(item.certificate_url)" class="hyper_button ml-3"> 
												<!-- <img class="ml-1" src="../../assets/images/icons/solid/file.svg" width="18"/> -->
												<img class=""  width="18" id="" src="../../assets/images/u224.svg"/>
											</a>
										</td>
									</tr>
								</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { EventBus } from './../../event_bus.js';

export default {
	props:{
		selects:{
			required: false
		},
		edit_view:{
			default: false,
			required: false
		},
		table_view:{
			default: false,
			required: false
		},
		create_view:{
			default: false,
			required: false
		},
		no_border:{
			default: false,
			required: false
		},
		provider_view:{
			default: false,
			required: false
		},

		
	},
	data : function(){
		return{
			selected_session:'',
			new_session_key: '',
			create_new_session: false,
			session_data:{
				name:'',
				supervisor:'',
				scheduled_at: null,
				properties:[
					
				],
				timing_method: 2, //pre defined timing method for session programs
			},
			disable_save: false,
			session_list:[],
			created_session: null,
			headers: ['Employee #', 'Name', 'Phone', '']
		}
	},
	computed : {
		router_origin(){
			if(this.$store.getters.getRole == 'csm'){
				return 'admin'
			}else{
				return 'organization'
			}
		},
		course_id(){
			if(this.selects && this.selects.value){
				return this.selects.value
			}else{
				return this.$route.params.id
			}
		},
		property_dictionary(){
			let dic ={}
			 this.session_data.properties.forEach( elem => {
				 if(elem.key && elem.value){
					 dic[elem.key] = elem.value
				 }
			})
			return dic
		},
		completed_session_view(){
			if(this.session_data && this.session_data.status){
				return this.session_data.status == "Completed"
			}else{
				return false
			}
		},

	},
	watch:{
		completed_session_view(val){
			if(val){
				this.headers[this.headers.length - 1] = "Certificate"
			}
		},
		course_id(){
			this.getSessionList()
		},
		create_new_session(val){
			this.$emit('sessionCreatingView', val)
		},
		session_data:{
			 handler: function(val) {
				 //fetch the name with dropdown
				if(val.name != null && val.name != '' && val.name != ' ' && this.provider_view){
					this.selected_session.name =  val.name
				}
				//form checker
				if((val.name == '' || val.name == null) || (val.supervisor == '' || val.supervisor == null) || (val.scheduled_at == '' || val.scheduled_at == null)){
					this.disable_save = true
					this.$emit('addProgramButtonDisable', true)
				}else{
					this.disable_save = false
					this.$emit('addProgramButtonDisable', false)
				}
			},
			deep: true
		},
		selected_session:{
			handler: function(val){
				//when changing the program on provider list -  reset thr dropdown and if session is chosen enable the add button
				if( (val.name != null && val.name != '' && val.name != ' ' && this.provider_view) &&
					!(this.create_new_session || this.create_view || this.edit_view)){
						this.$emit('addProgramButtonDisable', false)

				}
			},
			deep: true
		}
	},
	created : function(){
		if (this.$route.params.session_id){
			this.getSession()
		}else if(!this.create_view){
			this.getSessionList()
		} 
	},
	mounted: function(){
		EventBus.$on('cleanSessionForm', () =>{
			this.cleanSessionForm()
		})
		EventBus.$once('checkSessionStatus', () =>{
			//if new session, create it
			if(this.created_session && this.create_new_session){
				this.$emit('addProvidersToProgramWithSession', this.session_data)
			}
			else if(this.create_new_session || this.create_view){
				this.createSession()
			}else if(this.created_session){
				this.$emit('fetchSessionData', this.session_data)
			}
		})
	},
	methods : {	
		removeProvider(elem,index){
			this.$nextTick(() => {
				this.session_data.providers[index].removed = true
                this.$forceUpdate(); 

			});
		},	
		addProvider(elem,index){
			this.$nextTick(() => {
				this.session_data.providers[index].removed = false
                this.$forceUpdate(); 

			});
		},	
		getSessionList(){
			let course_id = ''
			if(!this.selects){
				course_id = this.$route.params.id
			}else{
				course_id = this.selects.value
			}
			var params = {
				course_id: course_id,
				id: this.$route.params.agency_id || '_',
				filters:{
					page_loading : false
				}
			}
			this.$store.dispatch('getSessions', params).then((res) => {
				this.session_list = res.data.data.filter( elem => {
					return elem.status != 'Completed'
				})
			})

		},
		getSession(){
			var params = {
				id: this.$route.params.session_id,
				filters: {
					providers: true
				}
			}
			if(this.router_origin == 'admin'){
				params.filters.organization_id = this.$route.params.agency_id
			}
			this.$store.dispatch('getSession', params).then((res) => {
				this.session_data = res.data.data
				this.fetchSessionDataOnForm(res)
				
			})
		},
		cleanSessionForm: function(){
			this.selected_session = ''
			this.new_session_key = ''
			this.create_new_session = false

			this.session_data = {
				supervisor:'',
				properties:[
					
				]
			}
		},
		assignCurrentSeach: function(search){
			this.new_session_key = search

		},
		createNewSessionActive: function(){
		
			this.session_data.name = this.new_session_key
			this.create_new_session = true
			this.selected_session = {
				name: ' ',
				key: -1
			}
			
		},
		insertCustomSessionInfo(id){
			let last_index = this.session_data.properties.length
			let last_id  = (last_index == 0) ? 0 : this.session_data.properties[last_index - 1].id 
			this.$validator.validateAll(['session_custom_key'+last_id, 'session_custom_value'+last_id]).then((result) => {
				this.$emit('addProgramButtonDisable', false)
				if(result){
					let next_key;
					if(this.session_data.properties.length == 0){
						next_key = 0
					}else{
						let next_index = this.session_data.properties.length - 1 
						next_key = this.session_data.properties[next_index].id + 1
					}
					this.session_data.properties.push({key:null, value:null , id: next_key})

				}else{
					this.$emit('addProgramButtonDisable', true)
				}
			})
		},
		createSession(){
			var params = this.session_data
			if(this.$route.params.agency_id){
				params.organization_id = this.$route.params.agency_id
			}
			params.course_id = this.course_id,
			params.scheduled_at = params.scheduled_at.split('T')[0]
			params.properties = this.property_dictionary
			this.$store.dispatch('createSession', params).then((res) => {
				if(this.table_view){
					this.created_session = res.data.data
					if(!this.create_view){
						this.sendSessionID(res)
					}
				}else{
					this.$router.push({ name : `${this.router_origin}.courses.detail`, params : { id : this.$route.params.id, section:'sessions' }})
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		sendSessionID(res){
			this.$emit('addProvidersToProgramWithSession', res.data.data.id)
		},
		saveSession(){
			let params = this.session_data
			params.scheduled_at = params.scheduled_at.split('T')[0]
			params.id = this.$route.params.session_id
			params.properties = this.property_dictionary
			
			//remove provider ids
			params.provider_ids = []
			this.session_data.providers.map( elem => {
					if(elem.removed){
						params.provider_ids.push(elem.provider_id)
					}else{
						return
					}
			})
			params.providers = this.session_data.providers.filter( elem => !elem.removed)
			
			if(this.router_origin == 'admin'){
				params.filters = {}
				params.filters.organization_id = this.$route.params.agency_id
			}

			this.$store.dispatch('editSession', params).then((res) => {
				this.session_data = res.data.data
				this.fetchSessionDataOnForm(res)
			})
		},
		removeSessionElement(index){
			this.session_data.properties.splice(index,1)
			// this.$store.dispatch('createSession', params).then((res) => {
			// 	console.log(res)
			// })
		},
		closed(){
			console.log('closed?')
		},
		fetchSessionDataOnForm(res){
			if(this.session_data.scheduled_at){
					this.session_data.scheduled_at = this.session_data.scheduled_at.split(' ')[0] + 'T00:00:00.000Z'
				}
				if(res.data.data.properties){
					let obj = JSON.parse(JSON.stringify(res.data.data.properties))
					this.session_data.properties = []
					let index = 0;
					for (const [key, value] of Object.entries(obj)) {
						this.session_data.properties.push({
							id:index,
							key:null,
							value:null
						})
						this.session_data.properties[index].key = key;
						this.session_data.properties[index].value = value;
					    ++index;
					}
					
				}

		},
		openProviderPage(){
			let route  = null
			if(this.router_origin == 'admin'){
				route =  this.$router.resolve({ name :'csm.providers.info', params : { agency_id : this.$route.params.agency_id }});
			}else{
				route = this.$router.resolve({ name :'organization.providers.index'});
			}
			window.open(route.href, '_blank');
		},
		downloadAllCertificates(cert){
			let certificate_url = cert ? cert: this.session_data.certificates_url
			if(this.router_origin == 'admin'){
				window.location.href = certificate_url+`&organization_id=${this.$route.params.agency_id}`
			}else{
				window.location.href = certificate_url
			}

		}
	}
}
</script>
<style>
.provider-removed{
	opacity: 0.3;
}
.button-position-display{
	display: flex;
	flex-direction: row-reverse;
    gap: 1rem;
	position: relative
}
.button-position-display > h5{
	position: absolute;
    top: 0;
    left: 0;
}
.hyper_button{
	text-decoration: underline !important;
	cursor: pointer;
	color: #11a5a7 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/sessionCreateView.vue